import { corporationMember } from "./corporationMember"
import { user } from "./user"
import { general } from "./general"

export const main = {
  corporationMember,
  general,
  user,
}
